import { render, staticRenderFns } from "./ModalReservationDetail.vue?vue&type=template&id=f37d3ff0&scoped=true&"
import script from "./ModalReservationDetail.vue?vue&type=script&lang=js&"
export * from "./ModalReservationDetail.vue?vue&type=script&lang=js&"
import style0 from "./ModalReservationDetail.vue?vue&type=style&index=0&id=f37d3ff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37d3ff0",
  null
  
)

export default component.exports